import React from 'react';
import BookAppointmentLink from './BookAppointmentLink';
import PricingSections from './PricingSections';
import { alacartePricing } from '../data/pricing';

const Services: React.FC = () => {
  const exam = alacartePricing.doctorExam;
  return (
    <section id="services" className="bg-white section-padding">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Hospital-grade safety without the hospital-grade bill — totally transparent, itemized pricing with no membership required.
          </p>
        </div>

        {/* Doctor exam */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gradient-to-r from-brand-teal/10 to-blue-50 rounded-3xl p-8 border-2 border-brand-teal/20 relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-brand-teal text-white text-xs font-bold px-3 py-1 rounded-bl-xl uppercase tracking-wider">
              Step 1
            </div>
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Doctor exam</h3>
                <p className="text-gray-600 mb-4">
                  We inspect the mouth, grade dental disease, and build a treatment plan. The exam is complimentary when you proceed with CHOMP-recommended dental care.
                </p>
                <ul className="space-y-2 inline-block text-left">
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="fas fa-check text-green-500 w-5 h-5 flex items-center justify-center"></i>
                    <span>Full oral health assessment</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="fas fa-check text-green-500 w-5 h-5 flex items-center justify-center"></i>
                    <span>Risk assessment</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="fas fa-check text-green-500 w-5 h-5 flex items-center justify-center"></i>
                    <span>Written plan with exact quote before procedures</span>
                  </li>
                </ul>
              </div>
              <div className="text-center bg-white p-6 rounded-2xl shadow-sm border border-gray-100 min-w-[200px]">
                <div className="text-gray-500 font-bold text-xs uppercase tracking-widest mb-1">
                  Exam fee
                </div>
                <div className="text-4xl font-extrabold text-gray-900 mb-1">{exam.displayPrice}</div>
                <div className="text-xs text-gray-500 leading-snug text-left max-w-[220px] mx-auto">{exam.finePrint}</div>
                <BookAppointmentLink className="mt-4 btn-primary w-full text-sm block">
                  Book exam
                </BookAppointmentLink>
              </div>
            </div>
          </div>
        </div>

        <PricingSections showTitles />

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500 bg-gray-50 inline-block px-4 py-2 rounded-lg max-w-2xl">
            <span className="font-bold text-gray-700">No surprises: </span>
            We provide a complete treatment plan with itemized costs after your exam, before anesthesia or treatment begins.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
